import _regeneratorRuntime from "D:/webproject/haoyu/wms-web/WMS/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "D:/webproject/haoyu/wms-web/WMS/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.string.iterator";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { getTableHead as _getTableHead, getTableSetHead as _getTableSetHead, saveTableSetHead as _saveTableSetHead } from '@/api/queryTemplate';
export default {
  name: 'ShowTableRow',
  components: {},
  props: {
    templateId: {
      type: String,
      default: ""
    }
  },
  data: function data() {
    return {
      checkAll: false,
      isIndeterminate: false,
      tableHeadSets: [],
      ff: [],
      tableHead: [],
      filterTableHead: []
    };
  },
  computed: {},
  created: function created() {
    var _this = this;
    Promise.all([this.getTableSetHead()]).then(function () {
      _this.getTableHead();
    });
  },
  methods: {
    saveTableSetHead: function () {
      var _saveTableSetHead2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
        var subData, result;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              subData = {
                list: [],
                templateCode: this.templateId
              };
              this.tableHeadSets.forEach(function (key) {
                subData.list.push({
                  fieldCode: key
                });
              });
              _context.next = 4;
              return _saveTableSetHead(subData);
            case 4:
              result = _context.sent;
              if (result.code === 200) {
                this.$message({
                  type: "success",
                  message: "提交成功"
                });
              } else {
                this.$message({
                  type: "error",
                  message: result.msg
                });
              }
            case 6:
            case "end":
              return _context.stop();
          }
        }, _callee, this);
      }));
      function saveTableSetHead() {
        return _saveTableSetHead2.apply(this, arguments);
      }
      return saveTableSetHead;
    }(),
    save: function save() {
      this.saveTableSetHead();
    },
    getTableSetHead: function () {
      var _getTableSetHead2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
        var result;
        return _regeneratorRuntime().wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              _context2.next = 2;
              return _getTableSetHead(this.templateId);
            case 2:
              result = _context2.sent;
              if (result.code === 200) {
                this.tableHeadSets = result.data.map(function (item) {
                  return item.fieldCode;
                });
              } else {
                this.$message({
                  type: "error",
                  message: result.msg
                });
              }
            case 4:
            case "end":
              return _context2.stop();
          }
        }, _callee2, this);
      }));
      function getTableSetHead() {
        return _getTableSetHead2.apply(this, arguments);
      }
      return getTableSetHead;
    }(),
    filterTableHeadFn: function filterTableHeadFn(isBol) {
      var _this2 = this;
      this.filterTableHead = this.tableHead.map(function (item) {
        item.isShow = false;
        if (_this2.tableHeadSets.some(function (p) {
          return p === item.fieldCode;
        })) {
          item.isShow = true;
        }
        return item;
      });
      this.$emit('callbackThead', this.filterTableHead, isBol);
    },
    getTableHead: function () {
      var _getTableHead2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee3() {
        var result;
        return _regeneratorRuntime().wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              _context3.next = 2;
              return _getTableHead(this.templateId);
            case 2:
              result = _context3.sent;
              if (result.code === 200) {
                this.tableHead = result.data.fields;
                this.checkAll = this.tableHeadSets.length === this.tableHead.length;
                this.isIndeterminate = this.tableHeadSets.length > 0 && this.tableHeadSets.length < this.tableHead.length;
                this.filterTableHeadFn(true);
              } else {
                this.$message({
                  type: "error",
                  message: result.msg
                });
              }
            case 4:
            case "end":
              return _context3.stop();
          }
        }, _callee3, this);
      }));
      function getTableHead() {
        return _getTableHead2.apply(this, arguments);
      }
      return getTableHead;
    }(),
    handleCheckAllChange: function handleCheckAllChange(val) {
      this.tableHeadSets = val ? this.tableHead.map(function (item) {
        return item.fieldCode;
      }) : [];
      this.isIndeterminate = false;
      this.filterTableHeadFn(false);
    },
    handleCheckedCitiesChange: function handleCheckedCitiesChange(value) {
      var checkedCount = value.length;
      this.checkAll = checkedCount === this.tableHead.length;
      this.isIndeterminate = checkedCount > 0 && checkedCount < this.tableHead.length;
      this.filterTableHeadFn(false);
    }
  }
};